export default function BidCheckmarkIcon({ twcss }: any) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={twcss || ''}
    >
      <circle
        cx="8.60593"
        cy="7.67136"
        r="7.2235"
        fill="#439A86"
        stroke="#439A86"
        strokeWidth="0.849823"
      />
      <path
        d="M4.69629 8.26105L7.43428 10.999L12.5365 5.89686"
        stroke="white"
        strokeWidth="0.849823"
      />
    </svg>
  )
}
